<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item">
              <base-input
                name="display"
                type="text"
                label="Codice del comparto"
                v-model="filter.byAttribute.display"
                placeholder="Inserisci un codice"
              />
            </div>
            <div class="filter-item">
              <base-input
                name="title"
                type="text"
                label="Descrizione del comparto"
                v-model="filter.byAttribute.title"
                placeholder="Inserisci una descrizione"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <sectors
        :fields="fields"
        :repository="repository"
        @manualFetch="manualFetch"
        :resource="resource"
        :filterName="filterName"
        :filterCount="countActiveFilters"
        :onlyActions="['infomodal']"
        :filterOn="{ byAttribute: { is_agency: 'N', is_system: 'N' } }"
        :ref="tableRef"
        noPagination
      ></sectors>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import BaseInput from "@/components/form/BaseInput";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import Sectors from "@/components/tables/CompanySummarySectors.vue";
import { mapActions } from "vuex";
import { toLocaleCurrency } from "@/utils/strings";
import { toLocaleDate } from "@/utils/dates";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, SidebarFilterMixin],
  data() {
    return {
      repository: "sector",
      resource: "sectors",
      tableRef: "CompanySectorsSummaryTableRef",
      filterName: "filterCompanySectorsSummary",
      filter: this.initFilter(),
      args: null,
      activeFilters: {},
      fields: [
        {
          key: "display",
          label: this.getDictionary("display", "sector"),
          sortable: true,
          sortKey: "display",
        },
        {
          key: "title",
          label: this.getDictionary("title", "sector"),
          sortable: true,
          sortKey: "title",
        },
        {
          key: "initial_balance_date",
          label: this.getDictionary("initial_balance_date", "sector"),
          formatter: (value) => toLocaleDate(value),
          sortable: true,
          sortKey: "initial_balance_date",
        },
        {
          key: "initial_balance",
          label: this.getDictionary("initial_balance", "sector"),
          formatter: (value) => toLocaleCurrency(value),
          sortable: true,
          sortKey: "initial_balance",
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "entry_tot",
          label: this.getDictionary("entry_tot", "sector"),
          formatter: (value) => toLocaleCurrency(value),
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
      ],
    };
  },
  components: {
    BaseIcon,
    Sectors,
    BaseInput,
  },
  computed: {
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
  },
  methods: {
    initFilter() {
      let init = {
        byAttribute: {
          display: null,
          title: null,
        },
      };
      return init;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
      // this.onSearch(name);
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
  },
};
</script>
